import { useEffect } from "react";
import socket from "../websocket";
import { EVENTS } from "../websocket/events";

export default function useSocket() {

    useEffect(() => {

        console.log("Socket instance:", socket);

        socket.onAny((event, ...args) => {
            console.log("Incoming:", event, args);
        });

        socket.on(EVENTS.CONNECT, () => {
            console.log("✅ Connected");
            console.log("Socket ID:", socket.id);
            console.log("Transport:", socket.io.engine.transport.name);
        });

        socket.on(EVENTS.DISCONNECT, (reason) => {
            console.log("❌ Disconnected:", reason);
        });

        socket.on(EVENTS.CONNECT_ERROR, (err) => {
            console.error("❌ Connection Error");
            console.error("Message:", err.message);
            console.error("Description:", err.description);
            console.error("Context:", err.context);
            console.error("Error: ", err);
        });

        socket.on(EVENTS.ERROR, (err) => {
            console.error("Socket Error:", err);
        });

        return () => {
            socket.off(EVENTS.CONNECT);
            socket.off(EVENTS.DISCONNECT);
            socket.off(EVENTS.CONNECT_ERROR);
            socket.off(EVENTS.ERROR);
        };

    }, []);

    return socket;
}